import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { SectionMessage } from 'app/modules/models/sectionMessage.type';
import { environment } from 'environments/environment';


@Injectable({
    providedIn: 'root'
})
export class SectionMessageService
{
    
    protected apiRoute = environment.RESOURCE_API;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }


    getAllActiveByPage(page : string): Observable<SectionMessage[]> {
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.getByPage + page; 
        return this._httpClient.get<SectionMessage[]>(route, this.prepareHeader());
     }

     getAllActive(): Observable<SectionMessage[]> {
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.getAllActive; 
        return this._httpClient.get<SectionMessage[]>(route, this.prepareHeader());
     }
 
    add(sectionMessage: SectionMessage){
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.add ;
        return this._httpClient.post(route, sectionMessage, this.prepareHeader()).pipe(map(res => res as any));
    }

    delete(sectionMessage : SectionMessage){
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.delete;
        return this._httpClient.post(route, sectionMessage ,this.prepareHeader()).pipe(map(res => res as any));
    }
    getActiveByName(name : string): Observable<SectionMessage> {
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.getByName + name; 
        return this._httpClient.get<SectionMessage>(route, this.prepareHeader());
     }
     getActiveBySectionId(sectionId : string): Observable<SectionMessage> {
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.getBySectionId + sectionId; 
        return this._httpClient.get<SectionMessage>(route, this.prepareHeader());
     }
    update(sectionMessage : SectionMessage){
        const route = this.apiRoute + environment.apiCatalog.sectionMessage.subRoutes.update;
        return this._httpClient.put(route, sectionMessage ,this.prepareHeader()).pipe(map(res => res as any));       
    }

    private prepareHeader(): Object { 
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        return { headers: headers };
    }
}
